import { FnI18nService } from '../../../i18n/fn-i18.service';
import { FnCheckboxEventFilter, FnCheckboxFilterOption } from './../fn-event-filter.model';
import { Component, OnInit, HostListener, ElementRef, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'fn-event-check-box-filter',
  templateUrl: './fn-event-check-box-filter.component.html',
  styleUrls: ['./fn-event-check-box-filter.component.scss']
})
export class FnEventCheckBoxFilterComponent implements OnInit {
  /**
   * Array FnCheckboxEventFilter to show on Filter
   */
  @Input() eventFilterArray: Array<FnCheckboxEventFilter>;
  /**
   * Text to show on Filter
   */
  @Input() filterText = this.i18Svcs.translate('Filter');
  /**
   * Align Filter
   */
  @Input() alignFilter = 'center';

  @Input() isFilterApplied = false;

  @Input() appendTo = '';
  /**
   * Emit event when Apply or rest filter button clicked
   */
  @Output() actionOnFilter = new EventEmitter<boolean>();
  /**
   * clone Array used to assign when user close filter after
   * changing selected Element without clicking on Apply or close button
   */
  private clonedFilterString: string;
  /**
   * object to bind properties on ui
   */
  uiEventFilterMap = {
    isClearDisabled: true,
    isApplyDisabled: true,
    isFilterApply: false,
    isOpenDropDown: false,
    fnBtnClass: 'btn-sm btn-round btn-outline-secondary dropdown-toggle',
    fnBtnIconClass: 'global-filter'
  };
  /**
   * used to store button class before Filter apply
   */
  private btnClassBeforeFilterApply = 'btn-sm btn-round btn-outline-secondary dropdown-toggle ';
  /**
   * * used to store button icon class before Filter apply
   */
  private btnIconClassBeforeFilterApply = 'global-filter';

  /**
   * Creates an instance of fn event filter component.
   * @param elemRef ElementRef ref
   */
  constructor(private elemRef: ElementRef,
    private i18Svcs: FnI18nService
  ) { }

  /**
   * Implementing on Init Method;
   * set default filter Class
   */
  ngOnInit() {
    this.uiEventFilterMap.fnBtnClass = this.btnClassBeforeFilterApply;
    this.uiEventFilterMap.fnBtnIconClass = this.btnIconClassBeforeFilterApply;
    this.uiEventFilterMap.isFilterApply = this.isFilterApplied;
  }

  /**
   * Method to Apply  Rest Event Filter
   * @param isFilterApply boolean value if true then filter applied
   */
  applyOrResetFilter(isFilterApply: boolean) {
    this.uiEventFilterMap.isClearDisabled = isFilterApply;
    this.uiEventFilterMap.isFilterApply = isFilterApply;
    this.uiEventFilterMap.isOpenDropDown = isFilterApply;
    this.uiEventFilterMap.isClearDisabled = !isFilterApply;
    this.changeFilterButtonClass();
    this.showOrHideDropDown(false, false);
    if (!isFilterApply) {
      for (let i = 0; i < this.eventFilterArray.length; i++) {
        this.eventFilterArray[i].parentOption.isSelected = true;
        this.selectOrUnselectAll(this.eventFilterArray[i]);
      }
    }
    this.actionOnFilter.emit(isFilterApply);
  }

  /**
   * Method to ser Action option and Enable Apply button when user select any other elements
   * @param event Event ref
   * @param fnEventFilter Event filter Object
   * @param fnFilterOption that is checked by user and set as activeOption
   */
  selectUnselectOption(
    event: Event,
    fnEventFilter: FnCheckboxEventFilter,
    fnFilterOption: FnCheckboxFilterOption
  ) {
    this.selectOrUnselectOption(fnFilterOption, fnEventFilter);
    this.uiEventFilterMap.isApplyDisabled = false;
  }
  selectUnSelectAll(event: Event, fnEventFilter: FnCheckboxEventFilter) {
    this.uiEventFilterMap.isApplyDisabled = false;
    this.selectOrUnselectAll(fnEventFilter);
  }

  /**
   * Method used to open and close Drop Down
   * @param isToOpen boolean value if False then filter opens else closed
   * @param isToRestFilter Optional value to rest filter to prev state when user
   * close dropdown when appy or reset button is not clicked
   */
  showOrHideDropDown(isToOpen: boolean, isToRestFilter?: boolean) {
    this.uiEventFilterMap.isApplyDisabled = true;
    this.uiEventFilterMap.isOpenDropDown = isToOpen;
    if (!isToOpen && isToRestFilter) {
      this.resetFilterToOldState()
    } else if (isToOpen) {
      this.clonedFilterString = JSON.stringify(this.eventFilterArray);
    }
  }
  /**
   * priavte method to change class when filter is Applied or reset
   */
  private changeFilterButtonClass() {
    if (this.uiEventFilterMap.isFilterApply) {
      this.uiEventFilterMap.fnBtnClass = this.btnClassBeforeFilterApply + ' filter-on';
      this.uiEventFilterMap.fnBtnIconClass = this.btnIconClassBeforeFilterApply + ' blue';
    }
    else {
      this.uiEventFilterMap.fnBtnClass = this.btnClassBeforeFilterApply;
      this.uiEventFilterMap.fnBtnIconClass = this.btnIconClassBeforeFilterApply;
    }
  }
  /**
   * method to close dropdown on outside click
   */
  closeDropDown() {
    if (this.uiEventFilterMap.isOpenDropDown) {
      this.showOrHideDropDown(false, true);
      event.stopPropagation();
    }
  }
  /**
   * Method resetFilterToOldState on close without clicking on reset or apply button;
   */
  private resetFilterToOldState() {
    const filterCloneArray = JSON.parse(this.clonedFilterString);
    for (let i = 0; i < filterCloneArray.length; i++) {
      const filterObj = this.eventFilterArray[i];
      const cloneObj = filterCloneArray[i];
      filterObj.parentOption = cloneObj.parentOption;
      filterObj.fnFilterOptionArray = cloneObj.fnFilterOptionArray;
      filterObj.noOfOptionSelected = cloneObj.noOfOptionSelected;
      filterObj.selectedOptionArray = cloneObj.selectedOptionArray;
    }
  }
  private selectOrUnselectAll(fnCheckboxEventFilter: FnCheckboxEventFilter) {
    fnCheckboxEventFilter.selectedOptionArray = [];
    const isAllSelected = fnCheckboxEventFilter.parentOption.isSelected;
    for (let i = 0; i < fnCheckboxEventFilter.fnFilterOptionArray.length; i++) {
      fnCheckboxEventFilter.fnFilterOptionArray[i].isSelected = isAllSelected;
      this.pushValueInArray(fnCheckboxEventFilter.fnFilterOptionArray[i], fnCheckboxEventFilter);
    }
    if (!isAllSelected) {
      fnCheckboxEventFilter.selectedOptionArray = [];
    }
    fnCheckboxEventFilter.noOfOptionSelected = fnCheckboxEventFilter.selectedOptionArray.length;
  }
  private selectOrUnselectOption(fnCheckboxFilterOption: FnCheckboxFilterOption, fnCheckboxEventFilter: FnCheckboxEventFilter) {
    if (fnCheckboxFilterOption.isSelected) {
      fnCheckboxEventFilter.noOfOptionSelected += 1;
      this.pushValueInArray(fnCheckboxFilterOption, fnCheckboxEventFilter);
      if (fnCheckboxEventFilter.noOfOptionSelected === fnCheckboxEventFilter.fnFilterOptionArray.length) {
        fnCheckboxEventFilter.parentOption.isSelected = true;
        return;
      }
    } else {
      fnCheckboxEventFilter.noOfOptionSelected -= 1;
      fnCheckboxEventFilter.parentOption.isSelected = false;
      for (let i = 0; i < fnCheckboxEventFilter.selectedOptionArray.length; i++) {
        if (fnCheckboxEventFilter.selectedOptionArray[i] + '_' + fnCheckboxEventFilter.primaryKey === fnCheckboxFilterOption.primaryKey) {
          fnCheckboxEventFilter.selectedOptionArray.splice(i, 1);
          return;
        }
      }
    }
  }
  private pushValueInArray(fnCheckboxFilterOption: FnCheckboxFilterOption, fnCheckboxEventFilter: FnCheckboxEventFilter) {
    fnCheckboxEventFilter.selectedOptionArray.push(fnCheckboxFilterOption.primaryKey.replace('_' + fnCheckboxEventFilter.primaryKey, ''));
  }

}
